const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

const splitMenu = () => {
  const menuWrapper = document.querySelector("#navigation .menu-level-1");
  if (!menuWrapper) return;

  setTimeout(() => {
    const menuItems = menuWrapper.querySelectorAll(
      ".menu-level-1>li:not(.appended-category)"
    );
    const menuHelper = document.querySelector(".menu-helper");

    // Reset before measuring so hidden items get correct dimensions
    menuItems.forEach((item) => item.classList.remove("splitted"));

    const navigationActions = document.querySelector(
      "#navigation .navigationActions"
    );
    const navActionsRect = navigationActions?.getBoundingClientRect();
    const container =
      menuWrapper.closest(".navigation-wrapper") ||
      menuWrapper.closest(".container");
    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const wrapperRight =
      (navActionsRect?.width > 0
        ? navActionsRect.left
        : container
        ? container.getBoundingClientRect().right
        : window.innerWidth) -
      4 * rem;

    menuItems.forEach((item) => {
      const itemRight = item.getBoundingClientRect().right;
      const itemInHelper =
        item.id === "nav-manufacturers"
          ? menuHelper.querySelector("#nav-manufacturers")
          : menuHelper.querySelector("." + item.classList[0]);
      if (itemRight > wrapperRight) {
        if (itemInHelper) itemInHelper.classList.remove("splitted");
        item.classList.add("splitted");
      } else {
        if (itemInHelper) itemInHelper.classList.add("splitted");
        item.classList.remove("splitted");
      }
    });

    if (
      menuHelper.querySelector(
        ".menu-level-1 > li:not(.splitted):not(.appended-category)"
      )
    ) {
      menuHelper.classList.remove("empty");
      menuWrapper.classList.remove("fitted");
    } else {
      menuHelper.classList.add("empty");
      menuWrapper.classList.add("fitted");
    }
  }, 200);
};

const recreateSignature = () => {
  const signature = document.querySelector("#signature");
  if (!signature) return;
  signature.style.display = "flex";
  const mirandaSignature = document.createElement("div");
  mirandaSignature.classList.add("miranda-signature");
  mirandaSignature.innerHTML = `
        <a href="https://www.mirandamedia.cz/shoptetnamiru" target="_blank">
            Vytvořila MirandaMedia Group s.r.o.
            <img src="/user/documents/upload/miranda/signature-icon.svg" width="27" height="22" alt="MirandaMedia logo" />
        </a>
        <span>na platformě</span>
    `;
  signature.prepend(mirandaSignature);
  const signatureLink = signature.querySelector(".title");
  if (!signatureLink) return;
  signatureLink.innerText = "Shoptet";
};

const handleFooterBottom = () => {
  const footerBottom = document.querySelector(".footer-bottom");
  if (!footerBottom) return;
  const footerBottomContainer = document.createElement("div");
  footerBottomContainer.classList.add("container");
  footerBottom.classList.remove("container");
  const footerBottomChildren = footerBottom.children;
  const footerBottomChildrenLength = footerBottomChildren.length;
  for (let i = 0; i < footerBottomChildrenLength; i++) {
    footerBottomContainer.appendChild(footerBottomChildren[0]);
  }
  footerBottom.appendChild(footerBottomContainer);

  const signature = footerBottomContainer.querySelector("#signature");
  if (signature) {
    const paymentImg = document.createElement("img");
    paymentImg.src = "/user/documents/upload/miranda/Payments.svg";
    paymentImg.alt = "Bezpečné platební metody";
    paymentImg.className = "footer-payments";
    signature.after(paymentImg);
  }
};

const handleFooter = () => {
  const footer = document.querySelector("#footer");
  if (!footer) return;
  const footerSiteName = footer.querySelector(".site-name");
  const footerLinksIcons = footer.querySelector(".footer-links-icons");
  if (footerSiteName && footerLinksIcons) {
    footerSiteName.appendChild(footerLinksIcons);
    footerLinksIcons.classList.remove("container");
  }
  const footerTel = footer.querySelector(".contact-box .tel");
  if (footerSiteName && footerTel) footerSiteName.appendChild(footerTel);
  const footerMail = footer.querySelector(".contact-box .mail");
  if (footerSiteName && footerMail) footerSiteName.appendChild(footerMail);

  const newsletter = footer.querySelector(".custom-footer__newsletter");
  if (newsletter) {
    const newsletterHeading = newsletter.querySelector("h4");
    if (newsletterHeading)
      newsletterHeading.innerHTML = "Přihlášení k odběru newsletteru";
    footer.prepend(newsletter);
  }
};

export {
  debounce,
  splitMenu,
  recreateSignature,
  handleFooterBottom,
  handleFooter,
};
